module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 17.62 11.78\"><g><path d=\"M17.61 11.54a.14.14 0 0 0 0-.09L12.84.15a.25.25 0 0 0-.3-.14l-5 1.3a.27.27 0 0 0-.12.06.23.23 0 0 0-.06.12v2.8L4.51 2.43a.28.28 0 0 0-.28 0L.11 5.25a.26.26 0 0 0-.11.24.25.25 0 0 0 .17.2l17.13 6.08h.08a.24.24 0 0 0 .22-.14ZM12.46.55l4.17 9.86L8.1 1.69Zm-4.6 1.6 7.57 7.74-7.62-5.2ZM.8 5.39l3.57-2.45 11.28 7.71Z\"/></g></svg>\n";


//////////////////
// WEBPACK FOOTER
// ./node_modules/html-loader!./src/assets/icons/icon-mail.svg
// module id = /5sT
// module chunks = 1